export default "__VITE_ASSET__CjYV_OEH__"